import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-catalogos',
  templateUrl: './catalogos.component.html',
  styleUrls: ['./catalogos.component.sass']
})
export class CatalogosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
